module.exports = __webpack_public_path__ + "img/scan_nfc.bb28614e.svg";